import { Component } from 'react';

// eslint-disable-next-line react/prefer-stateless-function
class Column extends Component {}

export default Column;
